import { useEffect } from "react";

// Microsoft Clarity — ready to activate.
// To enable: set REACT_APP_CLARITY_PROJECT_ID in frontend/.env and rebuild.
// Loads ONLY after the user accepts all cookies (GDPR).
const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;
const CONSENT_KEY = "scudononni_cookie_consent";

function hasFullConsent() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CONSENT_KEY));
    return parsed?.value === "all";
  } catch {
    return false;
  }
}

function loadClarity() {
  if (!CLARITY_ID || window.clarity) return;
  /* eslint-disable */
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
  /* eslint-enable */
  window.clarity("consent");
}

export default function MicrosoftClarity() {
  useEffect(() => {
    if (!CLARITY_ID) return;
    if (hasFullConsent()) loadClarity();
    const onConsentChange = (e) => {
      if (e?.detail?.value === "all") loadClarity();
    };
    window.addEventListener("scudononni:cookie-consent", onConsentChange);
    return () =>
      window.removeEventListener("scudononni:cookie-consent", onConsentChange);
  }, []);

  return null;
}
